import { PortfolioProfitsAndLosses } from "types/ProfitsAndLosses";
import { ActionType, getType } from "typesafe-actions";
import * as profitsAndLossesActions from "./profitsAndLossesActions";

export interface ProfitsAndLossesState {
  loading?: boolean;
  data?: PortfolioProfitsAndLosses[];
  error?: string;
}

export type ProfitsAndLossesActions = ActionType<
  typeof profitsAndLossesActions
>;

export default function profitsAndLosses(
  state: ProfitsAndLossesState = {},
  action: ProfitsAndLossesActions
) {
  switch (action.type) {
    case getType(profitsAndLossesActions.load):
      return { ...state, loading: true };
    case getType(profitsAndLossesActions.loadSuccess):
      const data = action.data?.map((d) => ({ ...d }));
      return { ...state, loading: false, data, error: undefined };
    case getType(profitsAndLossesActions.loadFail):
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
}
